import React, { Children, useEffect, useState } from "react";
import { FormSectionElements } from '../../entities/formTemplateDataType';
import { isFirstElement, isLastElement } from "../../utilities/ElementUtils";
import clock from "../../../public/assets/css/ontario-design-system/icons/svg/ontario-icon-clock.svg";


type TimeEstimateProps = {
    children?: React.ReactNode;
    field?: FormSectionElements;
}

const TimeEstimateCalloutComponent = ({
    children,
    field,
}: TimeEstimateProps) => {
    const [firstElement, setFirstElement] = useState(false);
    const [lastElement, setLastElement] = useState(false);

    useEffect(() => {
        setFirstElement(isFirstElement(field));
        setLastElement(isLastElement(field));
    }, []);

    return (

        <div>
            <div
                className={'ontario-callout ontario-callout-time-estimate ontario-callout-content callout-max-width'}>
                <div style={{display: 'flex'}}>
                    <img className={'ontario-callout-icon'} src={clock} alt=""/>
                </div>
                <div>
                    {children}
                </div>
            </div>
        </div>
    );
}

export default TimeEstimateCalloutComponent;